export function normalizePatientSearchQuery(value: string) {
  return value.trim().replace(/\s+/g, " ");
}

export function isPatientSearchQueryValid(value: string) {
  const normalized = normalizePatientSearchQuery(value);
  return normalized.length >= 2 && normalized.length <= 100;
}

export function isPatientSearchDateRangeValid(fromDate: string, toDate: string) {
  return !fromDate || !toDate || fromDate <= toDate;
}
